// custom options for `toast` function
export interface ToastOptions {
  label: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  toastType?: ToastTypes;
  id: string;
  subtext?: string | JSX.Element;
  startPause?: () => void;
  endPause?: () => void;
}

export enum ToastTypes {
  Success = 'Success',
  Error = 'Error',
  Info = 'Info',
}

export interface StyledProps {
  type?: ToastTypes;
  visible?: boolean;
}

// Define only the props ToastElement consumes directly to avoid pulling in
// react-hot-toast's internal Toast type (which requires `dismissed`).
export interface ToastElementProps extends ToastOptions {
  type?: string;
  message?: unknown;
  visible?: boolean;
  createdAt?: number;
  pauseDuration?: number;
  ariaProps?: { role: 'alert' | 'status'; 'aria-live': 'assertive' | 'polite' | 'off' };
  triggerFocus?: boolean;
}
